<app-loader [isLoading]="isLoading"></app-loader>

@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    @if (myroles.can_write) {
    <div class="top">
        <div class="boton">
            <button class="b1" mat-button (click)="goToNewMail()">Añadir actividad</button>
        </div>
    </div>
    }
</div>

<div class="content">
    <div class="filter">
        <div class="left-section">
            <div class="search-section">
                <mat-form-field appearance="outline" id="toppings">
                    <mat-label>Programación</mat-label>
                    <mat-select [formControl]="programmed" multiple>
                        @for (program of programmedList; track program) {
                        <mat-option [value]="program">{{program}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" id="toppings">
                    <mat-label>Destacado</mat-label>
                    <mat-select [formControl]="featured" multiple>
                        @for (feature of featuredList; track feature) {
                        <mat-option [value]="feature">{{feature}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="filter-buttons">
                @for (filter of filters; track filter.value){
                <button [class.active]="selectedFilter === filter.value" (click)="selectFilter(filter.value)">
                    {{ filter.label }}
                </button>
                }
            </div>
        </div>
        <div class="paginator-container">
            <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of the relation table"
                class="paginator-field">
            </mat-paginator>
        </div>
    </div>
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 table">

        <!-- Columna de Título -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
                TÍTULO
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.title | mailTitle}}</span>
            </td>
        </ng-container>

        <!-- Columna de Autor -->
        <ng-container matColumnDef="author">
            <th mat-header-cell *matHeaderCellDef>
                AUTOR
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.employee_external_id | qeqPipe}}</span>

            </td>
        </ng-container>
        
        <!-- Columna de ID -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
                ID
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.employee_external_id}}</span>

            </td>
        </ng-container>

        <!-- Columna de Publicación -->
        <ng-container matColumnDef="published-date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                PUBLICACIÓN
            </th>
            <td mat-cell *matCellDef="let element">
                @if(!element.published){
                <button mat-flat-button id="button">
                    <mat-icon matTextPrefix svgIcon="clock" style="transform: scale(1); left: 3px;"></mat-icon>
                    <span style="font-size: 16px;">{{element.publication_date | customPipe}}</span>
                </button>
                }@else{
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">{{element.created_when | customPipe}}</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de Fecha de notificaciones -->
        <ng-container matColumnDef="notifications">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                NOTIFICACIONES
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.notifications){
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">Sí</span>
                </button>

                }@else{
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">No</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de Destacado -->
        <ng-container matColumnDef="featured">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                DESTACADO
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.featured){
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">Sí</span>
                </button>

                }@else{
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">No</span>
                </button>
                }
            </td>
        </ng-container>

         <!-- Columna de Comentarios -->
        <ng-container matColumnDef="allow_comments">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                COMENTARIOS
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.allow_comments){
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">Sí</span>
                </button>

                }@else{
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">No</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de Reactiones -->
        <ng-container matColumnDef="allow_reactions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                REACCIONES
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.allow_reactions){
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">Sí</span>
                </button>

                }@else{
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">No</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de Imagenes -->
        <ng-container matColumnDef="allow_images">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                IMAGENES
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.allow_images){
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">Sí</span>
                </button>

                }@else{
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">No</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de Tags -->
        <ng-container matColumnDef="tags">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                TAGS
            </th>
            <td mat-cell *matCellDef="let element">
                @for(tag of element.tags | tags:4; track tag){
                <button mat-flat-button id="button-tag">
                    <span style="font-size: 16px;">{{tag.name}}</span>
                </button>
                }
                @if(element.tags.length > 4){
                <button mat-flat-button id="button-tag">
                    <span style="font-size: 16px;">...</span>
                </button>
                }
            </td>
        </ng-container>


        <ng-container matColumnDef="images_miniaturas">
        <th mat-header-cell *matHeaderCellDef>IMÁGENES SUBIDAS</th>
        <td mat-cell *matCellDef="let element">

        <div class="image-gallery" *ngIf="element.images?.length">
        <div class="image-wrapper"  *ngFor="let image of element.images"  >
          <img
            [src]="imageBaseUrl + image.image"
            class="thumbnail"
            [alt]="'Imagen del comentario ' + element.id"
            [matTooltip]="image.is_moderated ? 'Imagen moderada' : 'Imagen aprobada'"
            matTooltipPosition="above"
            (click)="moderarImagen(image)">
          <span *ngIf="image.is_moderated" class="moderation-icon moderated">✕</span>
          <span *ngIf="!image.is_moderated" class="moderation-icon approved">✓</span>
        </div>
        </div>
      </td>
    </ng-container>



        <!-- Columna de Acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element">
                <!-- <button mat-icon-button class="acciones"><mat-icon style="color: #2D3872;">info_outline</mat-icon></button> -->
                @if (myroles.can_write) {
                <button mat-icon-button class="acciones" (click)="goToMail(element)"><mat-icon
                        svgIcon="edit"></mat-icon></button>
                }
                @if (myroles.can_delete) {
                <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)"><mat-icon
                        svgIcon="delete"></mat-icon></button>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
}